// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_1UwaY","dialogHeader":"_1IOg5","dialogHeaderBack":"Qrh_A","dialogHeaderSorting":"_3IuZg","dialogHeaderClose":"_18HeH","dialogBody":"_1di6w"};